// Дата текущей редакции оферты (ISO). Меняется вместе с текстом оферты, ценой или сроком Pro.
export const OFFER_REVISION = "2026-11-02";
